import { render, staticRenderFns } from "./StatProvider.vue?vue&type=template&id=35536b87&scoped=true&"
import script from "./StatProvider.vue?vue&type=script&lang=js&"
export * from "./StatProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35536b87",
  null
  
)

export default component.exports